import { AHText, Box, useSpaceSize } from "arkh";
import React, { PropsWithChildren } from "react";
export function PageIndicator(props: {
  currentPage: number;
  numberOfItems: number;
}) {
  return (
    <PageIndicatorWrapper numberOfItems={props.numberOfItems}>
      <AHText type="subtitle">{props.currentPage}</AHText>
    </PageIndicatorWrapper>
  );
}
export function PageIndicatorWrapper(
  props: PropsWithChildren<{ numberOfItems: number }>
) {
  const minWidth = useSpaceSize("xlarge");
  return (
    <Box
      pointerEvents="none"
      style={{
        position: "absolute",
        right: 0,
        bottom: 0,

        justifyContent: "center",
      }}
      space="small"
    >
      <Box
        spaceHorizontal="small"
        spaceVertical="xsmall"
        cornerRadius="medium"
        shadow="medium"
        color="surface"
        style={{
          flexDirection: "row",
          alignItems: "baseline",
          minWidth,
          justifyContent: "flex-end",
        }}
      >
        {props.children}
        <AHText color="washedText" type="subtitle">
          {" / "}
          {props.numberOfItems}
        </AHText>
      </Box>
    </Box>
  );
}
